export default "__VITE_ASSET__Bwwlev5V__"